export default __webpack_public_path__ + "static/media/xButton.3b0391a3.PNG";